import {PeopleIcon} from '@primer/octicons-react'
import {ReviewerIdentity} from '../../../reviewers/ReviewerIdentity'
import {RelativeTime} from '@primer/react'
import styles from './CompletedReviewRow.module.css'
import type {CompletedReview} from '../../../../../page-data/payloads/review-requests'

export function CompletedReviewRow({review}: {review: CompletedReview}) {
  return (
    <li className={styles.fullReviewerRow}>
      <div className={styles.rowContent}>
        <div className={styles.fullReviewerHeader}>
          <span className={styles.reviewerWithTime}>
            <ReviewerIdentity reviewer={review.reviewer} />
            {review.submittedAt && (
              <span className={styles.reviewedAt}>
                <ReviewStateText state={review.state} hasWriteAccess={review.hasWriteAccess} />
                <RelativeTime datetime={review.submittedAt} />
              </span>
            )}
          </span>
        </div>

        {review.onBehalfOfTeams && review.onBehalfOfTeams.length > 0 && (
          <span className={styles.delegationNote}>
            <PeopleIcon size={12} />
            On behalf of{' '}
            {review.onBehalfOfTeams.map((team, i) => (
              <span key={team.id} className={styles.nestedTeamList}>
                <ReviewerIdentity reviewer={team} />
                {i < review.onBehalfOfTeams.length - 1 && <span className={styles.separator}>, </span>}
              </span>
            ))}
          </span>
        )}
      </div>
    </li>
  )
}

function ReviewStateText({state, hasWriteAccess}: {state: string; hasWriteAccess?: boolean}) {
  if (state === 'changes_requested') {
    return <>{hasWriteAccess ? 'requested changes' : 'suggested changes'}</>
  }

  if (state === 'approved') {
    return <>approved</>
  }

  return <>reviewed</>
}
